module.exports = __webpack_public_path__ + "img/market4_green.1b2ac241.svg";